module.exports = __webpack_public_path__ + "img/21.bb51bd18.png";